import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { isBrowser, isMobile } from 'react-device-detect';
import { useHistory } from 'react-router-dom';
import { UpgradeAccountContext } from '../../../../../contexts/settings/upgradeAccount/context';

const MainBodyLayout = ({
  children = null,
  withBack = false,
  onPrevClick = null,
  withInfoIcon = false,
  title = null,
  className = '',
}) => {
  const { openTerms } = useContext(UpgradeAccountContext);

  const history = useHistory();

  const closeUpgradeAccount = () => history.push('/dashboard/settings');

  return (
    <div
      style={{
        ...(isBrowser
          ? { flex: 1, overflowY: 'auto', paddingBottom: '12rem' }
          : { paddingBottom: '100px' }),
      }}
      className={`d-flex flex-column main-layout-body-container ${className} ${
        isBrowser ? 'hide-scroll' : ''
      }`}>
      {(withBack || withInfoIcon) && (
        <div className="d-flex flex-row justify-content-between align-items-center">
          {withBack && (
            <div
              className="cursor-pointer text-hover"
              onClick={onPrevClick}
              onKeyDown={onPrevClick}
              role="presentation">
              <i className="icon icon-arrow_back-navigation text-f5 me-2" aria-label="Back" />
            </div>
          )}
          {!withBack && withInfoIcon && (
            <p className={`text-dark ${isBrowser ? 'text-f3' : 'text-f4'}`}>{title}</p>
          )}
          <div className="d-flex flex-row align-items-center ">
            {withInfoIcon && (
              <>
                <div
                  className="cursor-pointer text-hover"
                  onClick={openTerms}
                  onKeyDown={openTerms}
                  role="presentation">
                  <i
                    className="icon icon-question-other text-shadow"
                    style={{ fontSize: isBrowser ? '1.2rem' : '1.7rem' }}
                  />
                </div>
              </>
            )}
            {isMobile && (
              <div
                onClick={closeUpgradeAccount}
                onKeyDown={closeUpgradeAccount}
                role="button"
                tabIndex={-1}>
                <i
                  className="close-btn cursor-pointer icon icon-close-other text-dark text-f4 ms-2"
                  aria-label="Close"
                />
              </div>
            )}
          </div>
        </div>
      )}
      {title && (
        <div
          className={`d-flex flex-row justify-content-start align-items-center ${
            isBrowser ? 'mt-4 mb-4' : 'mt-3'
          }`}>
          <p className={`text-dark ${isBrowser ? 'text-f3' : 'text-f4'}`}>{title}</p>
        </div>
      )}
      {children}
    </div>
  );
};

export default MainBodyLayout;

MainBodyLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  withBack: PropTypes.bool,
  withInfoIcon: PropTypes.bool,
  title: PropTypes.string,
  className: PropTypes.string,
  onPrevClick: PropTypes.func,
};
